<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useVoucherPOSStore } from '@/stores/vouchers/voucherPOSStore'
import { NXGDSModal } from '@nsftx/seven-nxg-design-system'
import { useVoucherStore } from '@nsftx/seven-client-retail-vue-sgp'
import SSVoucherDetailsTable from './SSVoucherDetailsTable.vue'
import SSVoucherDetailsModalHeader from './SSVoucherDetailsModalHeader.vue'
import SSVoucherDetailsModalFooter from './SSVoucherDetailsModalFooter.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const voucherPOSStore = useVoucherPOSStore()
const { isVoucherDetailsModalOpen } = storeToRefs(voucherPOSStore)
const { voucher } = storeToRefs(useVoucherStore())
</script>

<template>
  <NXGDSModal
    v-model="isVoucherDetailsModalOpen"
    :show-close-button="true"
    :title="t('common_voucher')"
    width="1200px"
  >
    <template #header>
      <SSVoucherDetailsModalHeader />
    </template>

    <SSVoucherDetailsTable v-if="voucher" :voucher="voucher" />

    <template #footer>
      <SSVoucherDetailsModalFooter />
    </template>
  </NXGDSModal>
</template>
